exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".certificate-list-page a{color:#7ab6f7;width:100%}.link{right:-128px}.links{right:-25px}.Requested{color:#ff0;font-weight:bold}.Approved{color:#51ff00;font-weight:bold}.Rejected{color:#ff3c00;font-weight:bold}.url-modal>div.child button .RejectButton{background-color:darkred;font-weight:bolder}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LibraryRequest/libraryPage.scss
// module id = 1674
// module chunks = 0